import { PageContainer } from '@/components'
import TaskListMain from './task-list-main'
const TaskList = () => (
  <PageContainer>
    <TaskListMain />
  </PageContainer>
)
export default TaskList
